import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importo delle traduzioni
import translationIT from './locales/it.json';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationFR from './locales/fr.json';
import translationDE from './locales/de.json';
import translationPT from './locales/pt.json';

// Le risorse di traduzione
const resources = {
  it: {
    translation: translationIT
  },
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  fr: {
    translation: translationFR
  },
  de: {
    translation: translationDE
  },
  pt: {
    translation: translationPT
  }
};

i18n
  // Rileva la lingua del browser
  .use(LanguageDetector)
  // Passa l'istanza i18n a react-i18next
  .use(initReactI18next)
  // Inizializza i18next
  .init({
    resources,
    fallbackLng: 'it', // Lingua predefinita se la traduzione richiesta non è disponibile
    lng: 'it', // Imposta italiano come lingua predefinita iniziale
    supportedLngs: ['it', 'en', 'es', 'fr', 'de', 'pt'], // Lista delle lingue supportate
    debug: process.env.NODE_ENV === 'development', // Mostra log solo in development

    interpolation: {
      escapeValue: false, // React si occupa già dell'escape
    },

    // Opzioni di rilevamento della lingua
    detection: {
      order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0, // Cerca la lingua nel primo segmento del path
      lookupQuerystring: 'lng', // Parametro URL per cambiare lingua (es: ?lng=en)
      lookupCookie: 'i18next', // Nome del cookie
      lookupLocalStorage: 'i18nextLng', // Chiave localStorage
      caches: ['localStorage', 'cookie'], // Dove memorizzare la lingua
      cookieExpirationDate: new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000), // Scadenza cookie: 2 anni
    }
  });

export default i18n;
